import React, { isValidElement } from 'react';
import { withPrefix, Link } from 'gatsby';
import queryString from 'query-string';
import { ToastContainer, toast } from 'react-toastify';
import TextareaAutosize from 'react-autosize-textarea';

const emailRegEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export default class ContactForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      locale: props.locale,
      email: '',
      name: '',
      company: '',
      phone: '',
      message: '',
      success: false,
      isValidEmail: true,
      isValidMessage: true,
    };
  }

submitForm = (e) => {
   const xhr = new XMLHttpRequest();
   const url = 'https://wmgtdq1duk.execute-api.eu-west-1.amazonaws.com/prd/contactForm'

   const data = {
    'submittedAt': Date.now(),
    'email': this.state.email,
    'name': this.state.name,
    'phone': this.state.phone,
    'company': this.state.company,
    'message': this.state.message,
  }

   data.message = "<br>" + data.message.replace(/(?:\r\n|\r|\n)/g, '<br>') 
   let final_data = JSON.stringify(data)

   xhr.open('POST', url);
   xhr.setRequestHeader('Content-type', 'application/json');

   xhr.onreadystatechange = () => {
     if (xhr.readyState === 4 && xhr.status === 200) {
       this.triggerSuccess();
     } else if (xhr.readyState === 4) {
       toast.error(`Please try again later!`);
       console.log('submission error', xhr)
     }
   }
   xhr.send(final_data)
}

triggerSuccess = () => {
   toast.success(`We received your message!`);
   this.setState({
     success: true,
   })

   setTimeout(() => {
     this.setState({
        email: '',
        name: '',
        company: '',
        phone: '',
        message: '',
        success: false,
        isValidEmail: true,
        isValidMessage: true,
      })
   }, 3000);
}
 

validateForm = (e) => {
  e.preventDefault();

  this.setState(
    {
      isValidEmail: emailRegEx.test(String(this.state.email).toLowerCase()),
      isValidMessage: this.state.message != '',
    },
    () => {
      if(this.state.isValidEmail && this.state.isValidMessage) this.submitForm(e);
    }
  )
  
}


onEmailInput = (e) => { 
  this.setState({
    email: e.target.value, 
    isValidEmail: this.state.isValidEmail ? true : emailRegEx.test(String(e.target.value).toLowerCase()) 
  });
 }

 onMessageInput = (e) => { 
  this.setState({
    message: e.target.value, 
    isValidMessage: this.state.isValidMessage ? true : this.state.message != '' 
  });
 }
 
 renderForm = () => {
    return (
      <form onSubmit={this.validateForm} className={this.state.success ? 'success' : ''}>

        <div className="form-field">
          <div className="label">{ this.state.locale === "en" ? "Name" : "Name" }</div> 
          <input 
            type="text" 
            onChange={(e) => { this.setState({ name: e.target.value }) }} 
            value={this.state.name} 
            placeholder={ this.state.locale === "en" ? "Enter first name and surname" : "Vorname und Nachname eintragen" } 
          />
        </div>

        <div className="form-field">
          <div className="label">{ this.state.locale === "en" ? "Company" : "Firma" }</div>
          <input 
            type="text" 
            onChange={(e) => { this.setState({ company: e.target.value }) }} 
            value={this.state.company} 
            placeholder={ this.state.locale === "en" ? "Enter company name" : "Firmenname eintragen" } 
          />
        </div>

        <div className={ "form-field " + (this.state.isValidEmail ? 'valid' : 'error') } >
          <div className="label">{ this.state.locale === "en" ? "Email" : "Email" } <span className="req">*</span> </div>
          <input 
            type="email" 
            onChange={this.onEmailInput} 
            value={this.state.email} 
            placeholder={ this.state.locale === "en" ? "Enter email" : "Email Adresse eintragen" } 
          />
          <p className="error-message">{ this.state.locale === "en" ? "Please enter a valid email Address!" : "Bitte geben Sie eine valide Email Adresse ein!" }</p>
        </div>

        <div className="form-field">
          <div className="label">{ this.state.locale === "en" ? "Phone" : "Telefon" }</div>
          <input 
            type="text" 
            onChange={(e) => { this.setState({ phone: e.target.value }) }} 
            value={this.state.phone} 
            placeholder={ this.state.locale === "en" ? "Enter phone number" : "Telefonnummer eintragen" } 
          />
        </div>

        <div className={ "form-field bottom-field " + (this.state.isValidMessage ? 'valid' : 'error') }>
          <div className="label">{ this.state.locale === "en" ? "Message" : "Nachricht" } <span className="req">*</span> </div>
            <TextareaAutosize
              className="text-area"
              rows={1}
              style={{resize: 'none'}} 
              onChange={this.onMessageInput} 
              value={this.state.message} 
              placeholder={ this.state.locale === "en" ? "Enter message" : "Nachricht eintragen" }
            />
            <p className="error-message">{ this.state.locale === "en" ? "Please enter a message before sending!" : "Bitte geben Sie eine kurze Nachricht ein!" }</p>
        </div>

        <p className="req">*Required Fields</p>
        <input className={"button is-rounded customers-button submit"} type="submit"/>
      </form>
    );
}


  render() {
    return (
      <div className="form-container">
        {this.renderForm()}
        <ToastContainer
          position="bottom-center"
          autoClose={4500}
          hideProgressBar
          closeOnClick={false}
          pauseOnHover={false}/>
      </div>
    );
  }
}
